// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 视频区域样式 */

.video-section {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}


.local-video-area {
  width: 100%;
}

.remote-video-area {
  width: 100%;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--gray-800);
  margin-bottom: 1.5rem;
  padding: 0 0.5rem;
}

.section-title i {
  color: var(--mango-500);
}

.remote-videos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 1.5rem;
}

/* 自定义滚动条样式 */
.video-section::-webkit-scrollbar {
  width: 8px;
}

.video-section::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 4px;
}

.video-section::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  transition: background 0.2s ease;
}

.video-section::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.3);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .video-section {
    gap: 1.5rem;
    height: auto;
    overflow-y: visible;
  }

  
  .remote-videos-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .section-title {
    font-size: 1rem;
    margin-bottom: 1rem;
  }
}

@media (max-width: 480px) {
  .video-section {
    gap: 1rem;
  }
  
  .section-title {
    font-size: 0.875rem;
    margin-bottom: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/VideoSection.css"],"names":[],"mappings":"AAAA,WAAW;;AAEX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;AACb;;AAEA,aAAa;AACb;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,UAAU;AACV;EACE;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;;EAGA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF","sourcesContent":["/* 视频区域样式 */\n\n.video-section {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n\n.local-video-area {\n  width: 100%;\n}\n\n.remote-video-area {\n  width: 100%;\n}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: var(--gray-800);\n  margin-bottom: 1.5rem;\n  padding: 0 0.5rem;\n}\n\n.section-title i {\n  color: var(--mango-500);\n}\n\n.remote-videos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));\n  gap: 1.5rem;\n}\n\n/* 自定义滚动条样式 */\n.video-section::-webkit-scrollbar {\n  width: 8px;\n}\n\n.video-section::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.3);\n  border-radius: 4px;\n}\n\n.video-section::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2);\n  border-radius: 4px;\n  transition: background 0.2s ease;\n}\n\n.video-section::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.3);\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .video-section {\n    gap: 1.5rem;\n    height: auto;\n    overflow-y: visible;\n  }\n\n  \n  .remote-videos-grid {\n    grid-template-columns: 1fr;\n    gap: 1rem;\n  }\n  \n  .section-title {\n    font-size: 1rem;\n    margin-bottom: 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .video-section {\n    gap: 1rem;\n  }\n  \n  .section-title {\n    font-size: 0.875rem;\n    margin-bottom: 0.75rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
